





















































































import Vue from 'vue'
import { Button } from 'element-ui'
import Interval from '@/components/Common/Interval'
import { SocialMediaStats } from '@/types/ops'
import SubscribeSocialMediaMonitor from '@/mixins/SubscribeSocialMediaMonitor'
import KisweInput from '@/components/Kiswe/KisweInput'
import './TwitterOps.scss'

interface SocialMediaTableItem {
  last_checked: string
  limits: string
  hashtags: string
  handles: string
  numtweets: number
  numigposts: number
  numpolls: number
}

export default Vue.extend({
  name: 'TwitterOps',
  mixins: [ SubscribeSocialMediaMonitor ],
  data: () => ({
    now: Date.now(),
    settings: {} as Partial<SocialMediaStats>,
    maxage: 0,
    showModal: false
  }),
  watch: {
    stats () {
      this.setupSettings()
    }
  },
  computed: {
    stats (): SocialMediaStats|null {
      return this.$store.direct.state.opsmonitor.socialMediaMonitor
    },
    twitterstats (): SocialMediaTableItem[] {
      const twitter: SocialMediaTableItem[] = []
      if (!this.stats) return twitter
      const last_checked = Math.round((this.now - this.stats.last_checked) / 1000) + 's ago'
      const limits = this.stats.limit.remaining + '/' + this.stats.limit.limit +
                    ' (refresh in ' + this.timeToString(this.stats.limit.reset - this.now / 1000) + ')'
      let hashtags = ''
      if (this.stats?.query?.hashtags !== undefined) {
        const hashtagList = Object.keys(this.stats.query.hashtags)
        hashtags = hashtagList.join(' ')
      }
      let handles = ''
      if (this.stats?.query?.handles !== undefined) {
        const handlesList = Object.keys(this.stats.query.handles)
        handles = handlesList.join(' ')
      }
      const numtweets = this.stats.num_tweets
      const numigposts = this.stats.num_igposts
      const numpolls = this.stats.num_polls
      twitter.push({
        last_checked,
        limits,
        hashtags,
        handles,
        numtweets,
        numigposts,
        numpolls
      })
      return twitter
    }
  },
  methods: {
    clockUpdate (): void {
      this.now = Date.now()
    },
    timeToString (sec: number): string {
      const minutes = Math.floor(sec / 60)
      const seconds = Math.floor(sec - minutes * 60)
      let result: string = '' + seconds
      if (seconds < 10) {
        result = '0' + seconds
      }
      return minutes + ':' + result
    },
    formSubmitted (): void {
      if (this.settings.interval === undefined) return
      if (this.settings.max_tweets_per_query === undefined) return
      if (this.settings.max_entries_per_asset === undefined) return
      this.settings.interval = Math.floor(this.settings.interval)
      this.settings.max_tweets_per_query = Math.floor(this.settings.max_tweets_per_query)
      this.settings.max_entries_per_asset = Math.floor(this.settings.max_entries_per_asset)
      this.settings.max_age_entry = Math.floor(this.maxage * (24 * 3600))
      this.$store.direct.dispatch.opsmonitor.updateSocialMediaMonitorSettings(this.settings)
      this.showModal = false
    },
    setupSettings (): void {
      if (this.stats === null) return
      if (this.settings.interval !== undefined) return
      this.settings.interval = this.stats.interval
      this.settings.max_tweets_per_query = this.stats.max_tweets_per_query
      this.settings.max_entries_per_asset = this.stats.max_entries_per_asset ?? 100
      this.settings.max_age_entry = this.stats.max_age_entry ?? 604800
      this.maxage = this.settings.max_age_entry / (24 * 3600)
      this.showModal = true
    }
  },
  components: {
    Interval,
    KisweInput,
    'el-button': Button
  }
})
